module.exports = __webpack_public_path__ + "img/line-chart-header.63448faf.svg";